import http from 'plugins/axios'

export default {
  list(data) {
    return http.get({
      url: '/ta/admin/tenant/welfare/task/list',
      data,
    })
  },
  detail(data) {
    return http.get({
      url: '/ta/admin/tenant/welfare/task/detail',
      data,
    })
  },
  add(data) {
    return http.post({
      url: '/ta/admin/tenant/welfare/task/add',
      data,
    })
  },
  update(data) {
    return http.post({
      url: '/ta/admin/tenant/welfare/task/update',
      data,
    })
  },
  updateStatus(data) {
    return http.post({
      url: '/ta/admin/tenant/welfare/task/updateStatus',
      data,
    })
  },
}
